export default {
  ERROR_MESSAGES: {
    TRACK_PARAMETERS_INVALID: 'Did not track. Event or configuration is invalid.',
  },
}
